import type { TAppEnv } from '@loc/types'

const SESSION_TOKEN_NAME = '__Secure-next-auth.session-token'
const CALLBACK_URL_NAME = '__Secure-next-auth.callback-url'
const CSRF_TOKEN_NAME = '__Host-next-auth.csrf-token'

export function getCookieDefaultOptions(domain?: string) {
  const result:
    | {
        sameSite: 'none'
        path: string
        secure: true
      }
    | {
        domain: string
        sameSite: 'none'
        path: string
        secure: true
      } = {
    sameSite: 'none',
    path: '/',
    secure: true,
  }

  if (domain) {
    return {
      ...result,
      domain,
    }
  }

  return result
}

function _getNextAuthCookieNames(prefix = '') {
  const result = {
    sessionTokenName: SESSION_TOKEN_NAME,
    callbackUrlName: CALLBACK_URL_NAME,
    csrfTokenName: CSRF_TOKEN_NAME,
  }

  if (prefix) {
    Object.keys(result).forEach((key) => {
      const resultKey = key as keyof typeof result
      result[resultKey] = prefix + result[resultKey]
    })
  }

  return result
}

export function getNextAuthCookieNames(env: TAppEnv) {
  return _getNextAuthCookieNames()
  // switch (env) {
  //   case 'development':
  //   case 'test':
  //     return _getNextAuthCookieNames(`[${env}-only]`)
  //   default:
  //     return _getNextAuthCookieNames()
  // }
}
